import useSWR from "swr";

export const useFetchSegmentCouponUsedUsersCount = (restaurantId: string, startDate: string|null, endDate: string|null) => {
  const { data: segmentCouponUsedUsersCount, error, isLoading: isLoadingSegmentCouponUsedUsersCount } = useSWR<number>(`membership/restaurants/${restaurantId}/line/segment-coupon/used-users/count/?startDate=${startDate}&endDate=${endDate}`)
  return { segmentCouponUsedUsersCount, isLoadingSegmentCouponUsedUsersCount, error };
};